<section class="jobs-section">
  <div class="jobs-container">
    <!-- Navbar -->
    <nav
      *ngIf="!isDashboard"
      class="flex items-center justify-between mb-4 md:mb-6 pb-3 md:pb-4 border-b border-slate-200"
    >
      <div class="flex items-center gap-4">
        <a routerLink="/" class="flex items-center">
          <img
            src="assets/images/BeExpert-logo (2).svg"
            alt="BeExpert"
            class="h-7 md:h-9 object-contain"
            onerror="this.src = 'assets/images/logo04.png'"
          />
        </a>
      </div>
      <div class="flex items-center gap-3">
        <button
          routerLink="/"
          class="text-sm font-medium text-slate-600 hover:text-indigo-600 transition hidden md:block"
        >
          Home
        </button>
        <button
          routerLink="/login"
          class="px-4 py-2 md:px-5 md:py-2.5 text-[13px] md:text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl shadow-sm transition-all ml-1 md:ml-2"
        >
          Login to Apply
        </button>
      </div>
    </nav>
    <!-- Header & Search -->
    <div
      class="mb-4 md:mb-6 bg-white p-3.5 md:p-5 rounded-2xl md:rounded-[1.5rem] shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-slate-100 relative overflow-hidden"
    >
      <!-- Decorative background -->
      <div
        class="absolute top-0 right-0 -mr-16 -mt-16 w-48 h-48 rounded-full bg-indigo-50 blur-3xl opacity-60 pointer-events-none"
      ></div>

      <div class="relative z-10">
        <div class="flex flex-wrap items-center gap-4 mb-1">
          <button
            [routerLink]="isDashboard ? '/student-dashboard/home' : '/'"
            class="inline-flex items-center gap-1.5 px-3.5 py-1.5 text-sm font-semibold text-slate-600 bg-white border border-slate-200 rounded-xl shadow-sm hover:bg-slate-50 hover:text-indigo-600 hover:border-indigo-200 transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            Back
          </button>
          <h2
            class="text-xl md:text-3xl font-black text-slate-900 tracking-tight"
          >
            All Mock Test <span class="brand-gradient-text">Openings</span>
          </h2>
        </div>
        <p
          class="text-slate-500 text-sm md:text-base font-medium max-w-2xl mb-3"
        >
          Browse every live mock test and start practicing in one click. Filter
          by subject or keyword.
        </p>

        <!-- Search Bar Container -->
        <div
          class="flex flex-col md:flex-row gap-3 bg-slate-50/80 p-1.5 rounded-xl border border-slate-200 backdrop-blur-sm"
        >
          <!-- Keyword -->
          <div class="relative flex-1">
            <svg
              class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
            <input
              type="text"
              [value]="searchQuery"
              placeholder="Search mock test..."
              class="w-full h-11 md:h-10 pl-10 pr-4 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all"
              (input)="onSearch($event)"
            />
          </div>

          <div class="flex gap-3 w-full md:w-auto flex-wrap md:flex-nowrap">
            <!-- Category Selector -->
            <div class="relative flex-1 md:min-w-[160px]">
              <select
                class="w-full h-11 md:h-10 px-4 bg-white border border-slate-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all appearance-none cursor-pointer"
                (change)="onCategoryChange($event)"
                [value]="selectedCategory"
              >
                <option *ngFor="let category of categories" [value]="category">
                  {{ category === "All" ? "All Categories" : category }}
                </option>
              </select>
              <svg
                class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </div>

            <!-- Role Selector -->
            <div class="relative flex-1 md:min-w-[160px]">
              <select
                class="w-full h-11 md:h-10 px-4 bg-white border border-slate-200 rounded-lg text-sm text-slate-700 appearance-none"
                (change)="onRoleChange($event)"
                [value]="selectedRole"
              >
                <option value="All">All Roles</option>

                <option *ngFor="let role of roles" [value]="role">
                  {{ role }}
                </option>
              </select>
              <svg
                class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jobs-grid">
      <ng-container *ngIf="isLoading">
        <div class="job-card" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
          <div class="animate-pulse flex space-x-4">
            <div
              class="rounded-xl bg-slate-100 h-14 w-14 border border-slate-200"
            ></div>
            <div class="flex-1 space-y-4 py-2 mt-1">
              <div class="h-3.5 bg-slate-200 rounded w-3/4"></div>
              <div class="space-y-3">
                <div class="h-3 bg-slate-100 rounded w-1/2"></div>
                <div class="h-3 bg-slate-50 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && mockTest.length === 0">
        <div
          class="col-span-full flex flex-col justify-center items-center py-20 px-4 text-center bg-white rounded-3xl border border-slate-100 shadow-sm mt-4 w-full"
        >
          <div
            class="w-20 h-20 bg-slate-50 rounded-2xl flex items-center justify-center mb-5 border border-slate-100"
          >
            <svg
              class="w-10 h-10 text-slate-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
          </div>
          <h3 class="text-xl font-bold text-slate-900 mb-2">
            No Mock Tests match your criteria
          </h3>
          <p class="text-slate-500 max-w-md mx-auto">
            Try adjusting your search keywords, category or role to find the
            mock tests you're looking for.
          </p>
          <button
            class="mt-6 px-6 py-2.5 bg-indigo-50 text-indigo-700 font-semibold rounded-xl hover:bg-indigo-100 transition-colors"
            (click)="
              searchQuery = '';
              selectedCategory = '';
              selectedRole = '';
              fetchMockTests(true)
            "
          >
            Clear All Filters
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && mockTest.length > 0">
        <div
          *ngFor="let test of mockTest; trackBy: trackByTestId"
          class="job-card"
        >
          <!-- Card Top: Logo & Title & Tag -->
          <div class="card-header-row">
            <div class="job-logo-box">
              <img
                [alt]="test.subject || test.classroom_name || 'General'"
                class="object-contain"
                loading="lazy"
                [src]="
                  test.company_logo ||
                  'https://ui-avatars.com/api/?name=' +
                    (test.company_name || 'MT')
                "
              />
            </div>
            <div class="title-column">
              <h3 class="job-title">{{ test.role_name || "-" }}</h3>
              <span class="tag-badge">
                {{ test.company_name || "-" }}
              </span>
            </div>
          </div>

          <!-- Card Middle: 2x2 Details Grid -->
          <div class="details-grid">
            <!-- Questions Count -->
            <div class="detail-item">
              <svg
                class="w-4 h-4 text-slate-400"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
                ></path>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" x2="12.01" y1="17" y2="17"></line>
              </svg>
              <span class="detail-text"
                >{{ test.totalQuestions }} Questions</span
              >
            </div>

            <!-- Test Duration -->
            <div class="detail-item">
              <svg
                class="w-4 h-4 text-slate-400"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <span class="detail-text"> {{ getTestDuration(test) }}</span>
            </div>
          </div>

          <!-- Card Bottom: Start Test Button -->
          <button
            class="btn-start-test"
            (click)="startMockTest(test)"
            [attr.data-testid]="'start-test-' + (test.link_id || test._id)"
          >
            <span>Start Mock Test</span>
            <svg
              aria-hidden="true"
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </ng-container>
    </div>

    <!-- Pagination 'Load More' Section -->
    <div
      class="flex justify-center mt-12 mb-8"
      *ngIf="mockTest.length > 0 && hasMore"
    >
      <button
        class="px-6 py-3 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl shadow-sm transition-all flex items-center justify-center disabled:opacity-70 disabled:bg-slate-400 disabled:cursor-not-allowed group"
        (click)="loadMore()"
        [disabled]="isLoadingMore"
      >
        <ng-container *ngIf="!isLoadingMore">
          Load More Mock Test
          <svg
            class="w-4 h-4 ml-2 transition-transform group-hover:translate-y-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            ></path>
          </svg>
        </ng-container>
        <ng-container *ngIf="isLoadingMore">
          <div
            class="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"
          ></div>
          Loading...
        </ng-container>
      </button>
    </div>
  </div>
</section>
